import { useEffect, useState } from 'react';
import { fetchBillingEnabled, setBillingEnabled } from '@/services/subscription';

export default function BillingToggle() {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBillingEnabled(true).then(setEnabled);
  }, []);

  const toggle = async () => {
    if (enabled === null || saving) return;
    const next = !enabled;
    setSaving(true);
    setError('');
    const { error: err } = await setBillingEnabled(next);
    setSaving(false);
    if (err) {
      setError(err);
      return;
    }
    setEnabled(next);
  };

  return (
    <div className="bg-background-100 rounded-lg border border-background-200/60 p-4 mb-4">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <i className="ri-bank-card-line text-primary-500" />
            <h3 className="text-sm font-semibold text-foreground-900">{t('admin.billing.title')}</h3>
            {enabled !== null && (
              <span
                className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${
                  enabled
                    ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                    : 'bg-background-200 text-foreground-600 border-background-300/60'
                }`}
              >
                {enabled ? t('admin.billing.on') : t('admin.billing.off')}
              </span>
            )}
          </div>
          <p className="text-[11px] text-foreground-500 mt-1 max-w-md">{t('admin.billing.help')}</p>
          {error && <p className="text-[11px] text-red-500 mt-1">{error}</p>}
        </div>

        <button
          type="button"
          role="switch"
          aria-checked={enabled === true}
          aria-label={t('admin.billing.toggle')}
          onClick={toggle}
          disabled={enabled === null || saving}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition disabled:opacity-50 cursor-pointer ${
            enabled ? 'bg-primary-500' : 'bg-background-300'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
              enabled ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  );
}
